import { useLayoutEffect } from 'react';
import { invalidateTokenCache, tokenColor } from '@/lib/tokens';
import { useAccountTheme } from '../accountTheme';
import '../../../styles/account-theme.css';

/** No persisted browser override: each authenticated identity supplies its own theme. */
export default function AccountThemeSync() {
  const theme = useAccountTheme();

  useLayoutEffect(() => {
    const root = document.documentElement;
    const meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
    const previousMeta = meta?.getAttribute('content');
    if (theme) root.dataset.accountTheme = theme;
    else delete root.dataset.accountTheme;
    invalidateTokenCache();
    if (theme && meta) meta.content = tokenColor('surface-page');
    return () => {
      delete root.dataset.accountTheme;
      invalidateTokenCache();
      if (meta && previousMeta !== null && previousMeta !== undefined) {
        meta.content = previousMeta;
      }
    };
  }, [theme]);

  return null;
}
